import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import './ValueInvestment.scss';
import { formatTextFloat, formatPercent } from '../../../helpers/Text';

class ValueInvestment extends React.Component {
  formatData = data => {
    const { averageIndex, averageStock } = data;
    let index = ['--', '--'];
    let stock = ['--', '--'];

    if (averageIndex && averageStock) {
      index = formatTextFloat(formatPercent(averageIndex)).split('.');
      stock = formatTextFloat(formatPercent(averageStock)).split('.');
    }

    return {
      index,
      stock,
    };
  };

  render() {
    const { title, firstStrName, secondStrName, color, data } = this.props;
    const getStyleColor = color => {
      let styleb = { backgroundColor: color };
      return styleb;
    };
    const formatedData = this.formatData(data);
    return (
      <div>
        <div className="value-investment">
          <div className="Rectangle" style={getStyleColor(color)}>
            <span className="Vis">{I18n.t(title)}</span>
          </div>
          <div className="value-text">
            <div className="Value-Investment-Str">
              <span>{firstStrName ? I18n.t(firstStrName) : ''}</span>
            </div>
            <div className="HIGH-RANKING-A-VAL">
              <span>{secondStrName ? I18n.t(secondStrName) : ''}</span>
            </div>
          </div>

          <div className="Rectangle-4">
            <div className="Rectangle-5">
              <span className="RETURN">{I18n.t('strategy.return')}</span>
            </div>
            <div className="Rectangle-6">
              <div className="number">{formatedData.stock[0]}</div>
              <div className="number-percent">{`.${
                formatedData.stock[1]
              }%`}</div>
            </div>
          </div>

          <div className="Rectangle-Index">
            <div className="Rectangle-5">
              <span className="RETURN">{I18n.t('strategy.vnIndex')}</span>
            </div>
            <div className="Rectangle-6">
              <div className="number">{formatedData.index[0]}</div>
              <div className="number-percent">{`.${
                formatedData.index[1]
              }%`}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ValueInvestment.defaultProps = {
  data: {
    averageIndex: null,
    averageStock: null,
  },
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(ValueInvestment);
